
<div class="outter_box">
<div *ngIf="annotation">

     
        <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

           
            <li class="fdm-linked fdm-options-button pointer" (click)="mapService.helper.sendCameraTo(annotation)" [matTooltip]="'MAP.FLY_TO' | translate">
            <fa-icon [icon]="annotation.icon"></fa-icon>
            </li>
            <h2>{{ annotation.name }} <sup><small><fa-icon icon="sync"  [spin]="loading" (click)="refreshSensor()"></fa-icon></small></sup></h2>
    
        </div>

  
        <table class="attribTable w-100 mt-3 mb-4">
          <tr *ngFor="let cur of annotation['attributes'];let i = index">
              <td width="40%">
                <input class="w-100 attrib_text"  placeholder=" {{'MAP.ATTRIBUTES_KEY' | translate }}" [(ngModel)]="cur.key">
              </td>
              <td>
                <input class="w-100 attrib_text" placeholder="{{'MAP.ATTRIBUTES_VALUE' | translate }}" [(ngModel)]="cur.value">
              </td>
              <td width="1%" class="text-right">
               <!--   <fa-icon icon="times" (click)="delAttrib(i)"></fa-icon> -->
              </td>
            </tr>
        </table>
        <div class="p-2 dropWell" (dragenter)="dragging=true" (dragleave)="dragging=false"
        (dragover)="dragOver($event)" (drop)="onDrop($event)" [ngClass]="{'primary-bg-light':dragging}">
           <img class="w-100" vlink="image.png" [model]="annotation" *ngIf="annotation['hasImage'] && !imageLoading"/>
           <div class="del" *ngIf="annotation['hasImage']"><fa-icon icon="trash" (click)="nukeImage()"></fa-icon></div>
           <label  *ngIf="!annotation['hasImage'] && !imageLoading">
               <div translate><fa-icon icon="image" size="2x"></fa-icon></div>
               MAP.UPLOAD
           </label>
           <mat-spinner style="margin:0 auto;" strokeWidth="3" *ngIf="imageLoading"></mat-spinner>
       </div>
    
   

        <div class="text-right">
            <small><i>{{ 'MAP.SYNCED' | translate }}: {{ annotation['lastSynced'] | qmap_moment:'fromNow'}}</i></small>
        </div>
        <!--
        <div class="text-right">
            <button mat-raised-button color="warn" (click)="del()" class="mr-1">{{ 'GENERIC.DELETE' | translate }}</button>
            <button [disabled]="deletingScreenShot" mat-raised-button color="primary" (click)="save(true)">{{ 'GENERIC.SAVE' | translate }}</button>
        </div>
        -->
    </div>
    

    
  
</div>

<mat-menu #pin="matMenu" [overlapTrigger]="false">
    <button mat-menu-item [matMenuTriggerFor]="colors">
        {{ 'GENERIC.COLOR' | translate }}
    </button>
    <button mat-menu-item [matMenuTriggerFor]="icons">
        {{ 'GENERIC.ICON' | translate }}
    </button>
</mat-menu>
<mat-menu #icons="matMenu" [overlapTrigger]="false">
    <button mat-menu-item
    *ngFor="let cur of ['map-pin','flag','exclamation-triangle']" (click)="annotation.icon = cur">
        <fa-icon [icon]="cur"></fa-icon>
    </button>
</mat-menu>

<mat-menu #colors="matMenu" [overlapTrigger]="false">
    <button mat-menu-item *ngFor="let cur of ['red','green','blue','yellow','orange','grey']"
        (click)="annotation.color = cur" [ngStyle]="{'background-color':cur}">
    </button>
</mat-menu>